import { useEffect, useState, PropsWithChildren, FC, useCallback } from 'react'
import { Spin } from 'antd'
import Card from '@/pages/Tbqy/components/components/Card'
import FullTable from '@/components/FullTable'
import * as api from '@/api/tbyqy'

type PropType = FC<PropsWithChildren<{
  updateTime: string
}>>

const Component:PropType = ({updateTime}) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)

  const getData = useCallback(async () => {
    setLoading(true)
    const res = await api.getDtbjgxm().finally(() => {
      setLoading(false)
    })
    if(res.success) {
      setData((res.data.list || []).map(r => ({
        tbr: r.投标人,
        cm: r.待填投标结果项目数
      })))
    } 
  }, [])

  useEffect(() => {
    getData()
  }, [getData, updateTime])

  return (
    <Spin spinning={loading} wrapperClassName='full-spin'>
      <Card title="待填投标结果项目" className='full-card'>
        <FullTable
          columns={
            [
              {title: '投标人', width: '50%', dataIndex: 'tbr'},
              {title: '待填投标结果项目数', width: '50%', dataIndex: 'cm'},
            ]
          }
          dataSource={data}
        />
      </Card>
    </Spin>
  )
}

export default Component
